import React, { Component } from "react";

import Modal from "../../lodging/components/modal";
import provisionalModuleDataBasedOnLanguage from "../../lodging/searchList/provisionalModuleDataBasedOnLanguage";

import { toCurrency } from "../../../utils/currency";
import Checkbox from "../../../components/checkboxGroup/checkbox";
import { getLanguageField } from "src/utils/language";
import Icon from "src/components/icon/icon";
import Image from "src/components/image";
import NumericStepper from "src/components/numericStepper";

export default class ServicesModal extends Component {
  state = {
    servicesModalProduct: this.props.product,
    servicesDetailModal: false
  }

  moduleData = provisionalModuleDataBasedOnLanguage(this.props.language)

  isRequiredService = () => {
    let isRequired = false;
    isRequired = this.state.servicesModalProduct.services?.filter(service => service.required_value === true).length > 0;
    return isRequired;
  }

  selectService = (service, quantity = undefined) => {
    const { servicesModalProduct } = this.state;
    const group_name = service.group_name;

    // Find services with the same product_id
    const relatedServices = servicesModalProduct.services.filter(
      (s) => s.group_name === group_name
    );

    const newServicesModalProduct = { ...servicesModalProduct };

    if (!newServicesModalProduct.complementary_products) {
      newServicesModalProduct.complementary_products = [];
    }

    const complementaryProducts = newServicesModalProduct.complementary_products;

    // Check if the service is already in the complementary_products array
    const serviceIndex = complementaryProducts.findIndex(
      (s) => s.product_id === service.product_id
    );

    if ((serviceIndex >= 0 && quantity === undefined) || (serviceIndex >= 0 && quantity === 0)) {
      // Service is being removed
      complementaryProducts.splice(serviceIndex, 1);

      // Remove related services from complementary_products
      for (const relatedService of relatedServices) {
        const relatedServiceIndex = complementaryProducts.findIndex(
          (s) => s.product_id === relatedService.product_id
        );
        if (relatedServiceIndex >= 0) {
          complementaryProducts.splice(relatedServiceIndex, 1);
        }
      }
    } else if (serviceIndex >= 0 && quantity > 0) {
      complementaryProducts[serviceIndex] = { ...complementaryProducts[serviceIndex], quantity }
    } else {
      // Service is being added
      complementaryProducts.push({ ...service, quantity: quantity });

      // Add related services to complementary_products
      for (const relatedService of relatedServices) {
        const relatedServiceIndex = complementaryProducts.findIndex(
          (s) => s.product_id === relatedService.product_id
        );
        if (relatedServiceIndex === -1) {
          complementaryProducts.push(relatedService);
        }
      }
    }

    this.setState({ servicesModalProduct: newServicesModalProduct });
  };

  updateServiceRequirement = (value, service) => {
    const newServicesModalProduct = { ...this.state.servicesModalProduct };
    const complementaryProducts = newServicesModalProduct.complementary_products;

    // Find the index of the service in the complementary_products array
    const serviceFound = complementaryProducts.find(s => s.product_id === service.product_id);
    const serviceIndex = complementaryProducts.indexOf(serviceFound);
    if (serviceIndex >= 0) {
      // Update the requirement value of the selected service
      complementaryProducts[serviceIndex].requirement.value = value;

      // Update the requirement value of all services with the same product_id
      const groupName = service.group_name;
      complementaryProducts.forEach((complementaryService, index) => {
        if (complementaryService.group_name === groupName) {
          newServicesModalProduct.complementary_products[index].requirement.value = value;
        }
      });
    }

    this.setState({ servicesModalProduct: newServicesModalProduct });
  }

  updateServiceNote = (note, service) => {
    const newServicesModalProduct = { ...this.state.servicesModalProduct };
    const complementaryProducts = newServicesModalProduct.complementary_products;

    // Find the index of the service in the complementary_products array
    const serviceFound = complementaryProducts.find(s => s.product_id === service.product_id);
    const serviceIndex = complementaryProducts.indexOf(serviceFound);
    if (serviceIndex >= 0) {
      // Update the note of the selected service
      complementaryProducts[serviceIndex].note = note;
    }

    this.setState({ servicesModalProduct: newServicesModalProduct });
  }

  disabledAddService = () => {
    let isButtonDisabled = false;
    if (!this.state.servicesModalProduct.complementary_products || this.state.servicesModalProduct.complementary_products.length === 0) isButtonDisabled = true;
    this.state.servicesModalProduct.complementary_products?.forEach(product => {
      if (product.requirement && !product.requirement.value) isButtonDisabled = true;
    })

    return isButtonDisabled;
  }

  getButtonLabel = () => {
    if(!this.props.roomsTotal || this.props.roomsTotal < 2) return this.moduleData.nextSelection;
    let label = this.moduleData.buttonValidateRoom.replace('{roomNumber}', this.props.numberOfRooms).replace('{roomsTotal}', this.props.roomsTotal);
    if(this.props.numberOfRooms === this.props.roomsTotal) label += ` ${this.moduleData.labelAddToCard}`;
    return label;
  }

  renderServices = () => {
    const { state, selectService, updateServiceRequirement, updateServiceNote } = this;
    const { servicesModalProduct } = state;

    const alreadyRenderedServices = [];
    const productPrices = {};

    return (
      <div className="flex flex-col gap-4">
        {servicesModalProduct.services?.map((service, idx) => {
          const foundService = servicesModalProduct.complementary_products?.find(serv => serv.product_id === service.product_id);
          const isRendered = alreadyRenderedServices.includes(service.group_name);

          if (isRendered) {
            return null;
          }

          const servicesWithSameRequirement = servicesModalProduct.services?.filter(
            (s) => s.requirement && s.group_name === service.group_name && s.group_name.length
          );

          const totalPrice = servicesWithSameRequirement.reduce((sum, s) => sum + s.price.price_value, 0);

          alreadyRenderedServices.push(service.group_name);
          productPrices[service.group_name] = totalPrice;

          const title = servicesWithSameRequirement.length > 1 ? getLanguageField(service.translations, this.props.language, "group_name") : getLanguageField(service.translations, this.props.language, "name");
          // const subtitle = getLanguageField(service.translations, this.props.language, "subtitle")
          const description = getLanguageField(service.translations, this.props.language, "description")
          const commentTitle = getLanguageField(service.translations, this.props.language, "comment_field")
          const price = service.requirement ? productPrices[service.group_name] : service.price.price_value;

          return (
            <div className="flex flex-col gap-3">
              {/* service info & quantity selection */}
              <div className="flex items-center justify-between gap-4">
                {/* checkbox, name, info toggle */}
                <div className="flex gap-4 items-center">
                  <Checkbox
                    label={title && title.length ? title : service.group_name ? service.group_name : service.product_name}
                    className={"w-full"}
                    labelClassName={`ml-auto`}
                    name={service.group_name ? service.group_name : service.product_name}
                    isChecked={foundService}
                    layout={false}
                    handleOptionsChange={() => selectService(service, foundService ? 0 : 1)}
                  />
                  {
                    description && service.image ?
                      <button className="hidden sm:block" onClick={() => this.setState({servicesDetailModal: service})}>
                        <Icon icon="Info"/>
                      </button>
                    : null
                  }
                </div>
                {/* price & quantity selector*/}
                <div className="flex gap-2 items-center"> 
                  {
                    service.variable_quantity ? 
                      <NumericStepper
                        quantity={foundService?.quantity || 0} 
                        min={0} 
                        max={service.maxQuantity}
                        layout="rounded"
                        onChange={(value) => selectService(service, value)}
                      />
                    :
                    null
                  }
                  <span className="generalTextBold text-end w-[6rem]">
                    {this.props.displayType === "incremental-pricing" ? <span>+</span> : null}
                    {toCurrency({ value: price, valueCurrency: "nok" })}
                  </span>
                </div>
              </div>
              {/* requirement, i.e hour selection */}
              {service.requirement ? (
                <select
                  disabled={!foundService}
                  className="w-fit rounded border-[#e5e7eb] pr-8 text-sm text-[#637381]"
                  value={service.requirement.value}
                  onChange={(event) => updateServiceRequirement(event.target.value, service)}
                >
                <option hidden value={undefined}>
                  --:--
                </option>
                {service.requirement.steps.map((step) => (
                  <option key={step.value} value={step.value}>
                    {step.label}
                  </option>
                ))}
              </select>
              ) : null}
              {/* additional comments */}
              {
                service.activate_comments && foundService ?
                <div>
                  <span className="text-sm mb-2 block">{commentTitle}</span>
                  <textarea
                    value={service.note}
                    onChange={(event) => updateServiceNote(event.target.value, service)}
                    className="p-5 placeholder:italic h-36 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
                : null
              }
            </div>
          );
        })}
      </div>
    );
  }

  closeServicesModal = (action) => {
    if (action === "skip") this.props.closeFn({ product: this.props.product })
    else if (action === "close") this.props.closeFn({ product: ""})
    else {
      this.props.closeFn({ product: this.state.servicesModalProduct })
    }
  }

  render() {
    const { isRequiredService, disabledAddService, renderServices, closeServicesModal, /*state, props*/ } = this;
    // const { open } = props;

    return (
      <>
        <Modal
          alignedCenter
          hideCloseButton={true}
          open={true}
          title={this.moduleData.optionalServices}
          subtitle={this.moduleData.optionalServicesSubtitle}
          size="small"
          footer={
            <div className="flex gap-4">
              {
              isRequiredService()
                ? null
                :
                  <button
                    className="w-full flex items-center justify-end border py-2.5 px-4 rounded-lg font-semibold text-[color:var(--primaryColor)] border-[color:var(--secondaryColor)]"
                    onClick={() => closeServicesModal("skip")}
                  >
                    <span className="mx-auto block">{this.moduleData.skip}</span>
                  </button>
              }
              <button
                disabled={disabledAddService()}
                className={`w-full flex items-center justify-end border py-2.5 px-4 rounded-lg font-semibold ${!disabledAddService() ? `bg-[color:var(--primaryColor)] text-[color:var(--secondaryColor)]`: "bg-gray-100 text-gray-400"}`}
                onClick={() => closeServicesModal()}
              >
                <span className="mx-auto block">{this.getButtonLabel( )}</span>
              </button>
            </div>
          }
        >
          <div className="mb-6 flex flex-col gap-4">
            {renderServices()}
          </div>
        </Modal>
        <Modal
          alignedCenter
          closeFn={() => this.setState({servicesDetailModal: false})}
          open={this.state.servicesDetailModal !== false}
          titleCentered
          size="small"
        >
          <div className="flex flex-col gap-4 pb-6">
            <Image src={this.state.servicesDetailModal.image} />
            <div className="flex flex-col gap-2 text-sm">
              <span className="font-semibold">
                {getLanguageField(this.state.servicesDetailModal.translations, this.props.language, "name")}
              </span>
              <span className="text-gray-500">
                {getLanguageField(this.state.servicesDetailModal.translations, this.props.language, "subtitle")}
              </span>
              {getLanguageField(this.state.servicesDetailModal.translations, this.props.language, "description", true)}
            </div>
          </div>
        </Modal>
      </>
    )
  }
}